import React from 'react';
import { formatDate, currencyFormat } from 'utilities/common';

const Table = ({ data }) => {
  if (!data || data?.ledgers === null) {
    return (
      <div className="row">
        <div className="empty col-lg-12 truck">
          <div className="truck-wrapper">
            <div className="truck">
              <div className="truck-container"></div>
              <div className="glases"></div>
              <div className="bonet"></div>
              <div className="base"></div>
              <div className="base-aux"></div>
              <div className="wheel-back"></div>
              <div className="wheel-front"></div>
              <div className="smoke"></div>
            </div>
          </div>
          <p className="empty-title">Buku Besar not found.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="table-responsive px-0 table-overflow">
      <table
        className="table table-vcenter card-table datatable border-bottom"
        width="100%"
      >
        <thead>
          <tr>
            <th
              className="text-center border-end"
              style={{ whiteSpace: 'initial', width: '7%' }}
            >
              Tanggal
            </th>
            <th
              className="border-end text-center"
              style={{ whiteSpace: 'initial', width: '15%' }}
            >
              No Bukti
            </th>
            <th
              className="border-end text-center"
              style={{ whiteSpace: 'initial', width: '25%' }}
            >
              Keterangan
            </th>
            <th
              className="border-end text-center"
              style={{ whiteSpace: 'initial', width: '10%' }}
            >
              Debit
            </th>
            <th
              className="border-end text-center"
              style={{ whiteSpace: 'initial', width: '10%' }}
            >
              Kredit
            </th>
            <th
              className="border-end text-center"
              style={{ whiteSpace: 'initial', width: '10%' }}
            >
              Saldo
            </th>
          </tr>
        </thead>
        <tbody className="bg-white graph">
          {data?.ledgers?.map((d, i) => (
            <tr key={i} className='border-bottom'>
              <td className="border-end" style={{width: '7%'}}>
                <div className="table-col text-center">
                  <div className="text-ellipsis">
                    {formatDate(d?.entry_date, 'DD/MM/YYYY')}
                  </div>
                </div>
              </td>
              <td className="border-end" style={{width: '15%'}}>
                <div className="table-col">
                  <div className="text-ellipsis text-uppercase">
                    {d?.ref_code}
                  </div>
                </div>
              </td>
              <td className="border-end" style={{width: '25%'}}>
                <div className="table-col">
                  {d?.note !== '' ? (
                    <>
                      <div className="text-ellipsis">
                        {d?.note}
                      </div>
                      <small className="info">
                        {d?.transaction_name}
                      </small>
                    </>
                  ): (
                    <div className="text-ellipsis">
                      {d?.transaction_name}
                    </div>
                  )}
                </div>
              </td>
              <td className="border-end" style={{width: '10%'}}>
                <div className="table-col text-end">
                  <div className="text-ellipsis fw-semibold text-uppercase">
                    {currencyFormat(d?.debit) }
                  </div>
                </div>
              </td>
              <td className="border-end" style={{width: '10%'}}>
                <div className="table-col text-end">
                  <div className="text-ellipsis fw-semibold text-uppercase">
                    {currencyFormat(d?.credit)}
                  </div>
                </div>
              </td>
              <td className="border-end" style={{width: '10%'}}>
                <div className="table-col text-end">
                  <div className="text-ellipsis fw-semibold text-uppercase">
                    {currencyFormat(d?.saldo)}
                  </div>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
